import { closeSnackbar, SnackbarKey } from "notistack";
import type { OptionsObject } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const closeAction = (key: SnackbarKey) => (
  <IconButton size="small" onClick={() => closeSnackbar(key)}>
    <CloseIcon fontSize="small" style={{ color: "#fff" }} />
  </IconButton>
);

const commonStyle = {
  color: "#fff",
  fontFamily: "Work Sans, sans-serif",
  fontSize: "14px",
  textAlign: "center" as const,
};

/** Jobs sit under the app header so they stay visible while the user keeps working. */
const jobToastStyle = {
  ...commonStyle,
  marginTop: "70px",
};

export const snackbarSuccessOptions: OptionsObject = {
  anchorOrigin: { vertical: "bottom", horizontal: "center" },
  style: { ...commonStyle, backgroundColor: "#82bea2" },
  action: closeAction,
};

export const snackbarWarningOptions: OptionsObject = {
  anchorOrigin: { vertical: "top", horizontal: "center" },
  style: { ...commonStyle, backgroundColor: "#f8943e", marginTop: "70px" },
  action: closeAction,
};

export const snackbarErrorOptions: OptionsObject = {
  anchorOrigin: { vertical: "bottom", horizontal: "center" },
  style: { ...commonStyle, backgroundColor: "#cc3300" },
  action: closeAction,
};

export const snackbarJobSuccessOptions: OptionsObject = {
  anchorOrigin: { vertical: "top", horizontal: "center" },
  style: { ...jobToastStyle, backgroundColor: "#82bea2" },
  action: closeAction,
};

export const snackbarJobWarningOptions: OptionsObject = {
  anchorOrigin: { vertical: "top", horizontal: "center" },
  style: { ...jobToastStyle, backgroundColor: "#f8943e" },
  action: closeAction,
};

export const snackbarJobErrorOptions: OptionsObject = {
  anchorOrigin: { vertical: "top", horizontal: "center" },
  style: { ...jobToastStyle, backgroundColor: "#cc3300" },
  action: closeAction,
};

export const MESSAGE_DELETE_OK = "Suppression effectuée";
export const MESSAGE_DELETE_FAILED = "Erreur de suppression";
